import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { LanguagesCode, supportedLanguages } from "./config/languages";

i18n
  .use(initReactI18next)
  .use(Backend)
  .use(LanguageDetector)
  .init({
    supportedLngs: supportedLanguages,
    fallbackLng: LanguagesCode.ENGLISH,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "sessionStorage", "navigator"],
      caches: ["sessionStorage", "localStorage"],
      convertDetectedLanguage: (lng) => {
        const detected = lng.slice(0, 2);
        if (supportedLanguages.includes(detected as LanguagesCode)) {
          return detected;
        }
        return LanguagesCode.ENGLISH;
      },
    },
    saveMissing: true,
  });

export default i18n;
